// InputNumber props for the revenue-percent commission rate. This is the
// DISPLAYED human percentage (0-100, two decimal places) — the x100 scaling
// to/from the stored integer (payroll_commission_rate.amount, see the
// schema.prisma column comment) happens at the getAmountDraft/save boundary
// in ClassCommissionPage.tsx, not here.
export const percentInputProps = {
  style: { width: "100%" } as const,
  min: 0,
  max: 100,
  step: 0.01,
  precision: 2,
  suffix: "%",
  // No +/- stepper — typed/pasted directly, same as the currency fields.
  controls: false,
};
